/**
 * Product Page template
 * This file contains logic specific to a template.
 * It is intended to ONLY be loaded on templates that require
 * this specific functionality.
 **/

// Vars
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

const NAME = "ProductPage";

const variantOptions = document.querySelector("variant-radios");
const radiosPickers = variantOptions?.querySelectorAll(".pack-picker");
radiosPickers ? require("./components/packsPicker") : "";
// Logic
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
/**
 * init - Initialize the page
 **/

document.addEventListener("DOMContentLoaded", () => {
	const container = document.createElement("div");
	const items = document.querySelectorAll(".brand_item");
	const productWrapper = document.querySelector(".product product-info");

	items.forEach((element) => {
		container.appendChild(element);
	});

	container?.classList.add("brands__wrapper");
	productWrapper.insertAdjacentElement("beforeend", container);
});
